import { render, staticRenderFns } from "./SithMesReportTemplateRoleEdit.vue?vue&type=template&id=2a08c958&"
import script from "./SithMesReportTemplateRoleEdit.vue?vue&type=script&lang=js&"
export * from "./SithMesReportTemplateRoleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports